module.exports = __webpack_public_path__ + "img/logo-asana.adf903ff.svg";